(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-metafield"] && !Shopify.designMode) return;
  try {
    
  // The continuous-autoplay carousel clones every slide so the loop can scroll
  // seamlessly (see #appendContinuousLoopClones in slideshow.js), and re-clones more
  // on every resize (#fillLoopWidth). Those clones are marked [inert] on purpose, which
  // blocks all pointer/keyboard interaction - no CSS can undo that. Scoped strictly to
  // this section's carousel (the data-testid below is unique to it) so other
  // slideshows/carousels keep their clones non-interactive.
  //
  // A MutationObserver watching only this carousel's container turned out to be
  // unreliable in practice (timing relative to when the clones actually get created is
  // hard to pin down), so this polls instead: cheap, scoped query, self-healing against
  // any clones added at any point for any reason.
  function fixCollectionCarouselClones() {
    document
      .querySelectorAll('[data-testid="collections-list-grid-metafield"] [data-slideshow-clone][inert]')
      .forEach((clone) => {
        clone.removeAttribute('inert');
        clone.querySelectorAll('a, button').forEach((el) => {
          el.tabIndex = -1;
        });
      });
  }

  fixCollectionCarouselClones();
  setInterval(fixCollectionCarouselClones, 500);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
